import { useContext, useEffect, useRef, useState } from "react";
// import { ScrollMenu, VisibilityContext } from "react-horizontal-scrolling-menu";
// import "react-horizontal-scrolling-menu/dist/styles.css";
import client from "../../../contentfulClient";
import "./LatestPosts.scss";
import { MainContext } from "../../../MainContext";

export const LatestPost = () => {
    const { posts, openModal, staticTexts: { learnMoreButton: learnMoreButton }, staticTexts: { latestPostTitle: latestPostTitle } } = useContext(MainContext);
    const reps = Array(6).fill(0); // Repeat to create overflow

    const menuRef = useRef<HTMLDivElement>(null);
    const scrollRef = useRef<number | null>(null);
    const [isPaused, setIsPaused] = useState(false);

    useEffect(() => {
        const el = menuRef.current;
        if (!el) return;

        const scroll = () => {
            if (!isPaused && el) {
                el.scrollLeft += 1.5;
                if (el.scrollLeft >= el.scrollWidth - el.clientWidth - 1) {
                    el.scrollLeft = 0;
                }
            }
            scrollRef.current = requestAnimationFrame(scroll);
        };

        scroll();

        return () => {
            if (scrollRef.current) cancelAnimationFrame(scrollRef.current);
        };
    }, [isPaused]);

    console.log(latestPostTitle)
    return (
        <div className="posts-container">
            <div className="latest-posts">
                <p className="header">{latestPostTitle.title}</p>
                <p className="subTitle">{latestPostTitle.subTitle}</p>

                <hr />
                <br />

                <div className="carousel-wrapper" ref={menuRef} onMouseEnter={() => setIsPaused(true)} onMouseLeave={() => setIsPaused(false)} style={{ overflowX: "auto", whiteSpace: "nowrap" }}>
                    <div style={{ display: "inline-flex" }}>
                        {reps.map((_, repIdx) =>
                            posts.map((post: any, i: number) => (
                                <div className="card" style={{ margin: "0 10px", flexShrink: 0 }} key={`${repIdx}-${i}`}>
                                    <img className="card-image" src={post.image} alt={post.title} />
                                    <div className="card-text">
                                        <div className="texts">
                                            <p className="card-header">{post.title}</p>
                                            <p className="text">{post.subTitle}</p>
                                        </div>
                                        <div className="btn-gray" onClick={() => openModal({...post})}>
                                            {learnMoreButton.text}
                                        </div>
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                </div>

                <br />
                <hr />
            </div>
        </div>
    );
};
